module.exports = __webpack_public_path__ + "img/calendar-arrow-down.64954a0f.svg";